/**
 * Shared by every surface that can fail a translation request: the interaction
 * properties column, the training-wide localization dialog, add-language, prop
 * presets and publish.
 *
 * The editor's ToastContainer dismisses after 1s, which is right for a
 * confirmation the editor asked for and wrong for a failure they did not. A
 * translation failure leaves gaps in a training that is about to be published,
 * so it stays up long enough to read.
 */
export const TRANSLATION_FAILURE_TOAST_MS = 6000;

/** The one message for a failed translation, so the wording cannot drift. */
export const TRANSLATION_FAILED_KEY = "interaction_translation.failed";
